exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._11LcMasep1W5FE-RvyX-MU{margin:0 auto;margin-top:20px;margin-bottom:20px}._1Ua76eM4Izm6KnHxc4Z305{line-height:1.43;width:100%}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/molecules/ItemKit/style.css"],"names":[],"mappings":"AAAA,yBACG,cAAe,AAEf,gBAAiB,AACjB,kBAAoB,CACtB,AAED,yBACG,iBAAkB,AAClB,UAAY,CACd","file":"style.css","sourcesContent":[".title {\n   margin: 0 auto;\n   \n   margin-top: 20px;\n   margin-bottom: 20px;\n}\n\n.content {\n   line-height: 1.43;\n   width: 100%;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"title": "_11LcMasep1W5FE-RvyX-MU",
	"content": "_1Ua76eM4Izm6KnHxc4Z305"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/molecules/ItemKit/style.css
// module id = 993
// module chunks = 0 1 2 3